import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import CarContractList from "../../components/CarContract/List/CarContractList";

const CarContractListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست معاملات ماشین",
            to: "/car-contract/list",
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <CarContractList />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default CarContractListPage;
